// Login form component - handles user authentication
import React, { useState } from "react";
import { useRestAuth } from "../../providers/RestAuthProvider";
import { useLocalization } from "../../providers/LocalizationProvider";
import { Input, Label } from "../ui/Input";
import { Button } from "../ui/Button";
import LanguageSelector from "../ui/LanguageSelector";
import logo from "../../assets/constellation-logo.png";

export default function Login(){
  // Get hooks for authentication and localization
  const { login } = useRestAuth();
  const { t } = useLocalization(); 

  // Form state
  const [name,setName] = useState(""); 
  const [password,setPassword] = useState("");

  // Handle form submission
  const onSubmit = async (e) => { 
    e.preventDefault();
    await login(name, password);
  };
  
  return (
    <div className="min-h-screen grid place-items-center bg-background p-4">
      <div className="w-full max-w-sm space-y-4">
        <div className="flex justify-end">
          <LanguageSelector />
        </div>
        <form onSubmit={onSubmit} className="bg-card rounded-lg border shadow-sm p-6 space-y-4">
          <div className="w-full flex justify-center">
            <img src={logo} alt="Constellation Sociale" width={128} height={128} style={{ width: 128, height: 128, objectFit: 'contain' }} />
          </div>
          <h1 className="text-xl font-bold flex justify-center">{t('auth.loginTitle')}</h1>
          <div className="space-y-2">
            <Label htmlFor="username">{t('auth.email')}</Label>
            <Input id="username" value={name} onChange={(e)=>setName(e.target.value)} required />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">{t('auth.password')}</Label>
            <Input id="password" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required />
          </div>
          <Button className="w-full" type="submit">{t('auth.connect')}</Button>
          <p className="text-xs text-muted-foreground">{t('auth.debugTip')}</p>
        </form>
      </div>
    </div>
  );
}